
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"toStroke",attrs:{"d":"M12.488 4.737c0 2.236-1.793 4.037-3.988 4.037-2.195 0-3.987-1.8-3.987-4.037S6.304.7 8.5.7c2.195 0 3.988 1.8 3.988 4.037z","stroke":"#042132","stroke-width":"1.4"}}),_c('path',{staticClass:"toStroke toFill",attrs:{"d":"M8.5 11.008c.641 0 1.261.091 1.848.25L8.5 14.671l-1.847-3.41a6.914 6.914 0 011.813-.254H8.5zm-7.6 5.81v2.728c0 .313.279.554.6.554h14c.321 0 .6-.24.6-.554v-2.728c0-3.823-3.419-6.918-7.6-6.918-4.181 0-7.6 3.095-7.6 6.918zm14 0v2.173H9.1v-2.953l2.363-4.363c2.045.978 3.438 2.914 3.438 5.143 0 0 0 0 0 0zm-12.8 0c0-2.229 1.393-4.165 3.437-5.142l2.364 4.363v2.952H2.1v-2.174z","fill":"#042132","stroke":"#042132","stroke-width":".2"}}),_c('path',{staticClass:"toStroke toFill",attrs:{"d":"M10.428 18.29h2.262a.554.554 0 00.553-.551.554.554 0 00-.553-.552h-2.262a.554.554 0 00-.552.552c0 .303.249.552.552.552z","fill":"#042132","stroke":"#042132","stroke-width":".2"}})])
          )
        }
      }
    